import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';
export const useLazyQueryWithErrorHandling = (query, errorHandler, options) => {
    const [fetch, response] = useLazyQuery(query, Object.assign({ fetchPolicy: 'cache-and-network' }, options));
    errorHandler(response.error);
    return [fetch, response];
};
export const useQueryWithErrorHandling = (query, errorHandler, options) => {
    const response = useQuery(query, Object.assign({ fetchPolicy: 'cache-and-network' }, options));
    errorHandler(response.error);
    return response;
};
export const useMutationWithErrorHandling = (mutation, errorHandler, options) => {
    const [fetch, response] = useMutation(mutation, options);
    errorHandler(response.error);
    return [fetch, response];
};
//# sourceMappingURL=index.js.map